// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    signInExistingAccountMiniSignInStyles,
    signInExistingAccountStyles,
} from "@guestsupply/Overrides/Widgets/SignIn/SignInExistingAccount";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

signInExistingAccountStyles.container = {};

signInExistingAccountMiniSignInStyles.container = signInExistingAccountStyles.container;

signInExistingAccountMiniSignInStyles.icon = signInExistingAccountStyles.icon;

signInExistingAccountStyles.icon = {
    css: css`
        padding-top: 50px;
        &&& {
            background: transparent;
        }
    `,
};

signInExistingAccountMiniSignInStyles.signInExistingAccountTitle = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 16px;
    `,
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 0,
    offsetCss: css`
        row-gap: 16px;
    `,
};

signInExistingAccountMiniSignInStyles.signInGridContainer = signInExistingAccountStyles.signInGridContainer;

signInExistingAccountStyles.userNameGridItem = {
    width: 12,
};

signInExistingAccountMiniSignInStyles.userNameGridItem = signInExistingAccountStyles.userNameGridItem;

signInExistingAccountStyles.passwordGridItem = {
    width: 12,
    css: css`
        position: relative;
        ${({ isMiniSignIn }: any) => (isMiniSignIn ? "padding: 0 15px 5px;" : "padding: 0;")}
    `,
};

signInExistingAccountMiniSignInStyles.passwordGridItem = signInExistingAccountStyles.passwordGridItem;

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        margin-top: 4px;
    `,
};

signInExistingAccountMiniSignInStyles.signInButtonGridItem = signInExistingAccountStyles.signInButtonGridItem;

signInExistingAccountStyles.rememberMeGridItem = {
    width: 6,
    css: css`
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    `,
};

signInExistingAccountMiniSignInStyles.rememberMeGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    `,
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};

signInExistingAccountMiniSignInStyles.forgotPasswordLink = {
    typographyProps: {
        size: 10,
        weight: 600,
        css: css`
            &&&& {
                line-height: 11px;
            }
        `,
    },
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        weight: 600,
        css: css`
            &&&& {
                line-height: 13px;
            }
        `,
    },
};

signInExistingAccountStyles.signInButton = {
    css: css`
        margin-top: 4px;
    `,
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "medium",
};

signInExistingAccountMiniSignInStyles.resetPasswordModal = signInExistingAccountStyles.resetPasswordModal;

signInExistingAccountStyles.changePasswordModal = {
    sizeVariant: "small",
};

signInExistingAccountMiniSignInStyles.signInGridContainer = {};

signInExistingAccountMiniSignInStyles.signInButtonGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

signInExistingAccountMiniSignInStyles.forgotPasswordGridItem = {
    width: 6,
};

signInExistingAccountMiniSignInStyles.passwordTextField = {
    cssOverrides: {
        formField: css`
            label {
                justify-content: space-between;
            }
        `,
    },
};
